import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { faChartLineUp } from '@fortawesome/pro-solid-svg-icons/faChartLineUp';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faSackDollar } from '@fortawesome/pro-solid-svg-icons/faSackDollar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { SmartlinksMusicMarketingBox } from '../SmartlinksMusicMarketingBox';
import { nextAsset } from '../../../../components/nextAsset';
import { PlaylistsSharingGetAccessButton } from '../../playlistsSharing/PlaylistsSharingGetAccessButton';

export const SmartlinksMarketingPlaylist: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-music-marketing py-5">
      <Container className="py-5">
        <Row>
          <Col>
            <h2 className="main-header text-center pt-5 pb-3 text-secondary">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.playlist.music-marketing.title',
                defaultMessage: 'Stand out as music influencer'
              })}
            </h2>
          </Col>
        </Row>
        <Row className="align-items-stretch py-5">
          <SmartlinksMusicMarketingBox icon={faMegaphone}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.playlist.music-marketing.box1',
                defaultMessage: '<b>BOOST YOUR STREAMS</b> by routing to the music platforms of their choice'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faChartLineUp}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.playlist.music-marketing.box2',
                defaultMessage: 'Get access to almost <b>20x bigger audience</b>'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faSackDollar}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.playlist.music-marketing.box3',
                defaultMessage: 'Attract new listeners and grow your <b>influence</b>'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
        </Row>
      </Container>
      <div className="smartlinks-brand bg-primary">
        <Container className="py-5">
          <Row>
            <Col xs={12} className="d-flex d-lg-none justify-content-center">
              <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="MR eazi brand" className="img-fluid" />
            </Col>
            <Col>
              <h2 className="main-header pt-5 pb-3 text-white text-center text-lg-start">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.toolset.title',
                  defaultMessage: 'Access the most professional toolset that is being used by top music companies '
                })}
              </h2>
              <ul className="fa-ul pt-5">
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.toolset.promote',
                    defaultMessage: 'Promote your playlists with sleek landing pages and smart URLs'
                  })}
                </li>
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.toolset.embed',
                    defaultMessage: 'Embed Smart Links on your website'
                  })}
                </li>
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.toolset.audience',
                    defaultMessage:
                      'Learn more about your listeners with audience insights, measure views & clicks and much more'
                  })}
                </li>
              </ul>
              <div className="d-flex justify-content-center justify-content-lg-start ps-4">
                <PlaylistsSharingGetAccessButton
                  className="text-white text-center align-items-center"
                  isHighlighted
                  source="Playlists Page Marketing"
                />
              </div>
            </Col>
            <Col className="d-none d-lg-block pt-5">
              <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="Mr Eazi brand" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
